<ng-container *ngIf="!!elementtype">
    <tt-input
        *ngIf="isTextInput"
        [ttRequired]="required"
        [ttLabel]="label"
        ttTranslateLabel="false"
        [(ttModel)]="model"
        (ttModelChange)="modelChange.emit($event)"
        [ttReadonly]="readonly"
        (ttOnBlur)="blur.emit()"
    ></tt-input>
    <tt-textarea
        *ngIf="isTextAreaInput"
        [ttRequired]="required"
        [ttLabel]="label"
        ttTranslateLabel="false"
        [(ttModel)]="model"
        (ttModelChange)="modelChange.emit($event)"
        [ttReadonly]="readonly"
        (ttOnBlur)="blur.emit()"
    ></tt-textarea>
    <tt-input-number
        *ngIf="isNumberInput"
        [ttRequired]="required"
        [ttLabel]="label"
        ttTranslateLabel="false"
        [(ttModel)]="model"
        (ttModelChange)="modelChange.emit('' + $event)"
        [ttDecimals]="decimals"
        [ttReadonly]="readonly"
        (ttOnBlur)="blur.emit()"
    ></tt-input-number>
    <tt-editor
        *ngIf="isEditorInput"
        [ttRequired]="required"
        [ttLabel]="label"
        ttTranslateLabel="false"
        [(ttModel)]="model"
        (ttModelChange)="modelChange.emit($event)"
        [ttReadonly]="readonly"
        (ttOnBlur)="blur.emit()"
    ></tt-editor>
    <tt-select
        *ngIf="isDropdownInput"
        [ttRequired]="required"
        [ttLabel]="label"
        ttTranslateLabel="false"
        [(ttModel)]="model"
        (ttModelChange)="modelChange.emit($event)"
        [ttData]="data"
        ttDataId="productsettingmcitem_keyno"
        ttDataName="productsettingmcitem_name"
        [ttReadonly]="readonly"
        (ttOnBlur)="blur.emit()"
    ></tt-select>
    <tt-input
        *ngIf="isCounterInput"
        [ttRequired]="required"
        [ttLabel]="label"
        ttTranslateLabel="false"
        [(ttModel)]="model"
        (ttModelChange)="modelChange.emit($event)"
        [ttReadonly]="readonly"
        (ttOnBlur)="blur.emit()"
    >
        <tt-form-field-button *ngIf="!hideCounterAfterAssign || !numberAssigned" buttons ttIcon="far fa-plus" (ttClick)="loadNextCounter()"></tt-form-field-button>
    </tt-input>
</ng-container>
